import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";

export default {
  name: "customers",
  components: {},
  props: [],
  data() {
    return {
      current: 1,
      slider: null,
      items: [
        {
          image: "hotel_ghasr.svg",
          width: 163,
          height: 88,
        },
        {
          image: "darokhane_niavaran.svg",
          width: 142,
          height: 97,
        },
        {
          image: "clinic.svg",
          width: 56,
          height: 128,
        },
        {
          image: "eram_kish.png",
          width: 214,
          height: 118,
        },
        {
          image: "flightio.png",
          width: 200,
          height: 63,
        },
        {
          image: "homsa.png",
          width: 213,
          height: 53,
        },
        {
          image: "samtik.png",
          width: 130,
          height: 95,
        },
      ],
    };
  },
  computed: {},
  mounted() {
    // setInterval(()=>{this.slider.next()},7000)
    this.slider = new KeenSlider(
      this.$refs.slider,
      {
        loop: true,
        rtl: true,
        breakpoints: {
          "(max-width: 400px)": {
            slides: { perView: 1, spacing: 5 },
          },
          "(min-width: 1000px)": {
            slides: { perView: 3, spacing: 10 },
          },
        },
        slides: {
          perView: 1,
          spacing: 10,
        },
      },
      [
        (slider) => {
          let timeout;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => {
              slider.next();
            }, 5000);
          }
          slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          slider.on("dragStarted", clearNextTimeout);
          slider.on("animationEnded", nextTimeout);
          slider.on("updated", nextTimeout);
        },
      ]
    );
  },
  beforeDestroy() {
    if (this.slider) this.slider.destroy();
  },
  methods: {},
};
